import { IconFunctionalHelpCircle16, Tooltip, UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './PublicationPrice.css';
import { formatNumber } from '../../../../../../utils/string';
import { NNBSP } from '@cian/ui-kit/internal/constants/char';

export interface IPublicationPriceProps {
  discountPrice: string | null;
  price: number;
  days: string;
  hintHeader?: string;
  hintTitle?: string;
}

export const PublicationPrice = ({ discountPrice, price, days, hintHeader, hintTitle }: IPublicationPriceProps) => {
  return (
    <div className={styles['wrapper']}>
      {discountPrice && (
        <div className={styles['discount_price']}>
          <UIHeading4 color="gray60_100">{discountPrice}</UIHeading4>
        </div>
      )}

      <UIHeading4>{formatNumber(price)}</UIHeading4>
      {NNBSP}
      <UIText2>₽/{days}</UIText2>

      {hintTitle && (
        <div className={styles['hint']}>
          <Tooltip header={hintHeader} title={hintTitle} theme="black">
            <IconFunctionalHelpCircle16 color="primary_100" cursor="pointer" />
          </Tooltip>
        </div>
      )}
    </div>
  );
};
